import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { isApiErrorMessage } from 'src/api/utils/is-api-error-message';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { bookingsApiErrorsTranslations } from '../../constants/api-errors-translations';
import { cancelBooking } from '../lib/bookings';
import { bookingsQueryKeys } from '../query-keys/bookings';
import { ApiErrorMessage } from '../types/api-error-message';

export const useCancelBooking = (onSuccess?: () => void) => {
  const { t } = useTranslation(['bookings', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bookingToken: string) => cancelBooking(bookingToken),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: bookingsQueryKeys.lists(),
        });
      });
      toast.success(t('bookings:common.cancelBookingDialog.successMessage'));
      onSuccess?.();
    },
    onError: (error: ApiError) => {
      const errorMessage = error?.response?.data?.message;

      if (
        isApiErrorMessage<ApiErrorMessage>(
          errorMessage,
          bookingsApiErrorsTranslations,
        )
      ) {
        toast.error(t(bookingsApiErrorsTranslations[errorMessage]));

        return;
      }
      toast.error(errorMessage || t('common:errorMessages.somethingWentWrong'));
    },
  });
};
